import { setupModal } from "@near-wallet-selector/modal-ui";
import { WalletSelector } from "@near-wallet-selector/core";

export const authSelector = async (selector: Promise<WalletSelector>) => {
	const modal = setupModal((await selector)!, {
		contractId: "",
	});
	modal.show();
};
